/** Distance (px) to slide each underline in from off-screen right. */
const OFFSCREEN_PAD_PX = 32;

export const STICKY_AUDIO_UNDERLINE_ANIM_MS = 260;

export function measureStickyAudioUnderlineTravel(layer: ParentNode): void {
  if (typeof window === 'undefined') return;
  const viewportRight = window.innerWidth;
  layer.querySelectorAll<HTMLElement>('.sticky-audio-mark').forEach((mark) => {
    const rect = mark.getBoundingClientRect();
    const travel = Math.max(0, viewportRight - rect.right + OFFSCREEN_PAD_PX);
    mark.style.setProperty('--sticky-audio-travel-x', `${travel}px`);
  });
}

export function clearStickyAudioUnderlineTravel(layer: ParentNode): void {
  layer.querySelectorAll<HTMLElement>('.sticky-audio-mark').forEach((mark) => {
    mark.style.removeProperty('--sticky-audio-travel-x');
  });
}

/** Stable identity for a dotted underline so scope changes can animate only new words. */
export function listStickyAudioMarks(layer: ParentNode): Array<{ mark: HTMLElement; key: string }> {
  const counts = new Map<string, number>();
  const rows: Array<{ mark: HTMLElement; key: string }> = [];
  layer.querySelectorAll<HTMLElement>('.sticky-audio-mark').forEach((mark) => {
    const phrase = (mark.textContent ?? '').replace(/\s+/g, ' ').normalize('NFC').trim().toLowerCase();
    const seen = counts.get(phrase) ?? 0;
    counts.set(phrase, seen + 1);
    rows.push({ mark, key: `${phrase}\0${seen}` });
  });
  return rows;
}

export function clearStickyUnderlineMotion(mark: HTMLElement): void {
  mark.removeAttribute('data-sticky-underline');
  mark.removeAttribute('data-sticky-instant');
}
